import defaultState from './state';

const SET_SHOW_SALES_POPUP = (state, showSalesPopup) => {
  state.showSalesPopup = showSalesPopup;
};

const SET_SHOW_THEMATIC_BANNER = (state, showThematicBanner) => {
  state.showThematicBanner = showThematicBanner;
};

const SET_SHOW_LIBRARY_BANNER = (state, showLibraryBanner) => {
  state.showLibraryBanner = showLibraryBanner;
};

const SET_SHOW_ISLAND_BANNER = (state, showIslandBanner) => {
  state.showIslandBanner = showIslandBanner;
};

const SET_SALES_FLOW = (state, promotion) => {
  if (promotion.bannerType === undefined || promotion.bannerType === null) {
    // TODO: call DESTROY
    Object.keys(defaultState).forEach((key) => {
      state[key] = defaultState[key];
    });
  } else {
    if (state.showSalesPopup === null && (promotion.bannerType === 'no_product_without_trial' || promotion.bannerType === 'no_product_with_trial')) {
      state.showSalesPopup = true;
    } else if (promotion.bannerType === 'no_product_without_trial' || promotion.bannerType === 'no_product_with_trial') {
      state.showSalesPopup = false;
    } else {
      state.showSalesPopup = true;
    }
    state.showThematicBanner = true;
    state.showLibraryBanner = true;
    state.showIslandBanner = true;
  }
};

const DESTROY = (state) => {
  Object.keys(defaultState).forEach((key) => {
    state[key] = defaultState[key];
  });
};

export default {
  SET_SHOW_SALES_POPUP,
  SET_SHOW_THEMATIC_BANNER,
  SET_SHOW_LIBRARY_BANNER,
  SET_SHOW_ISLAND_BANNER,
  SET_SALES_FLOW,
  DESTROY,
};
